export enum SocialLoginType {
    "google" = "google",
    "fb" = "fb",
}
